/*
 * Module for the Service Purhase Time Block edit partial view
*/

rs.module("content/participant/member/servicepurchase/timeblockedit",

    ["controls/data/grid", "controls/components/event-banner"],

    function (gridModule, eventBanner) {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls, interestGridLrsApi, modelVars) {

            var form = $.js(jsSelectors.form);

            form.js(jsSelectors.contributionAmount).keyup(_toggleCalculateInterestButton);
            form.js(jsSelectors.toDate).change(_toggleCalculateInterestButton);

            const penaltyEndDate = modelVars?.penaltyEndDate ? new Date(modelVars.penaltyEndDate) : null;

            form.js(jsSelectors.calculateInterestButton).click(function () {

                _clearErrors();

                // show loading spinner
                form.js(jsSelectors.spinner).show();

                gridModule.update(
                    backendUrls.loadInterestSchedule,
                    {
                        balance: form.js(jsSelectors.contributionAmount).val(),
                        balanceDate: penaltyEndDate ? penaltyEndDate.toISOString() : null,
                        timeBlockFromDate: form.js(jsSelectors.fromDate).val(),
                        timeBlockToDate: form.js(jsSelectors.toDate).val(),
                    },
                    interestGridLrsApi.agGridApi,
                    function done(gridUpdate) {

                        form.js(jsSelectors.interestAmount).val(gridUpdate.context.interestAmount);

                        // show interest schedule
                        form.js(jsSelectors.interestSchedule).show();
                    }

                ).fail(function () {

                    form.js(jsSelectors.interestAmount).val(null);

                    // hide interest schedule
                    form.js(jsSelectors.interestSchedule).hide();

                }).always(function () {

                    // hide loading spinner
                    form.js(jsSelectors.spinner).hide();
                });
            });

            //
            // Enable or disable the calcualte interest button based on the Contribution and To Date fields
            //
            function _toggleCalculateInterestButton() {
                var hasContribution = form.js(jsSelectors.contributionAmount).normalizedCurrencyVal() > 0;
                var hasToDate = !!form.js(jsSelectors.toDate).val();
                var hasPenaltyEnd = !!penaltyEndDate;

                var enabled = hasContribution && hasToDate && hasPenaltyEnd;
                form.js(jsSelectors.calculateInterestButton).setDisabled(!enabled);
            }

            //
            // Clear event banner and field errors
            //
            function _clearErrors() {

                // clear event banner
                eventBanner.removeAllMessages();
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);